import {
  BrainCircuit,
  Drone,
  Factory,
  Plane,
  Radar,
} from 'lucide-react';

const ICON_BY_CATEGORY = {
  Unmanned: Drone,
  Airspace: Radar,
  Manned: Plane,
  AI: BrainCircuit,
  Manufacturing: Factory,
};

const iconProps = {
  size: 100,
  strokeWidth: 2.75,
  absoluteStrokeWidth: true,
  'aria-hidden': true,
};

/**
 * @param {{ category: string, className?: string, style?: import('react').CSSProperties }} props
 */
export function CategoryIcon({ category, className, style }) {
  const Icon = ICON_BY_CATEGORY[category];
  if (!Icon) return null;
  return <Icon className={className} style={style} {...iconProps} />;
}
